/** Display grouping for pricing catalog buckets (no DB category column). */

export const RATE_CATEGORY_ORDER = ["remote", "onsite", "app_dev", "flat"];

export const RATE_CATEGORY_LABELS = {
    remote: "Remote / shop time",
    onsite: "Onsite (hourly only)",
    app_dev: "App development (remote)",
    flat: "Flat / lump sum",
};

/** Buckets that must stay hourly — no day bundles for travel/onsite or remote app work. */
export const HOURLY_ONLY_RATE_KEYS = new Set([
    "onsite_billed",
    "onsite_day",
    "onsite_field",
    "app_development",
    "app_development_multi",
]);

export function categoryForRateKey(rateKey) {
    const k = String(rateKey || "");
    if (k.startsWith("app_")) return "app_dev";
    if (k.startsWith("onsite")) return "onsite";
    if (k.endsWith("_flat") || k === "nre_flat") return "flat";
    return "remote";
}

export function isHourlyOnlyRate(rateKey) {
    return HOURLY_ONLY_RATE_KEYS.has(String(rateKey || ""));
}

export function groupRatesByCategory(rates) {
    const buckets = {};
    for (const id of RATE_CATEGORY_ORDER) buckets[id] = [];
    (rates || []).forEach((r) => {
        const cat = categoryForRateKey(r.rate_key);
        if (!buckets[cat]) buckets[cat] = [];
        buckets[cat].push(r);
    });
    return buckets;
}

export function groupPresetsByCategory(presets) {
    const buckets = {};
    for (const id of RATE_CATEGORY_ORDER) buckets[id] = [];
    (presets || []).forEach((p) => {
        const rk = p.rate_key;
        const cat = categoryForRateKey(rk);
        if (!buckets[cat]) buckets[cat] = [];
        buckets[cat].push(p);
    });
    return buckets;
}

export const QTY_HOUR_STEPS = [1, 2, 4, 8];
